<template>
  <div style="position: relative">
    <div class="dropdown-overlay" v-if="show" @click="show_dropdown"></div>
    <div class="select" @click.stop.prevent="show_dropdown">
      <select
        class="custom-select dropdown-height"
        @mousedown.stop.prevent
        :style="select_style"
      >
        <option value="" selected>{{ content_preview }}</option>
      </select>
    </div>
    <div class="dropdown" v-if="show">
      <ul>
        <li>
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              @change="allClick()"
              :value="value_all"
              class="custom-control-input"
              v-model="all_selected_values"
              :id="'chb-all'"
            />
            <label class="custom-control-label" :for="'chb-all'">{{
              value_all.display_text
            }}</label>
          </div>
        </li>
        <li
          v-for="option in options"
          :key="option.value"
          @click="transfer_click_to_label"
        >
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              :value="option"
              class="custom-control-input"
              v-model="selected_values"
              :id="'chb' + option.value + option.display_text"
            />
            <label
              class="custom-control-label"
              :for="'chb' + option.value + option.display_text"
              >{{ option.display_text }}</label
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      show: false,
      selected_values: [],
      value_all: {
        value: "ALL",
        display_text: this.$t("message.comply_advantage.filter_countries_all"),
      },
      all_selected_values: [],
      isCheckedAll: false,
    };
  },
  methods: {
    transfer_click_to_label(event) {
      if (event.target && event.target.querySelector("label"))
        event.target.querySelector("label").click();
    },
    show_dropdown() {
      this.show = !this.show;
    },
    allClick(event) {
      console.log("selected values", this.selected_values.length);
      if (this.isCheckedAll) {
        this.selected_values = [];
      } else {
        this.selected_values = [];
        this.options.forEach((opt) => {
          this.selected_values.push(opt);
        });
      }
      this.isCheckedAll = !this.isCheckedAll;
    },
  },
  watch: {
    selected_values: {
      deep: true,
      handler() {
        this.$emit("input", this.selected_values);
      },
    },
  },
  mounted() {
    console.log("mounted options", this.options);
    setTimeout(() => {
      this.isCheckedAll = true;
      this.selected_values = this.options;
      this.all_selected_values.push(this.value_all);
    }, 500);
  },
  computed: {
    content_preview() {
      if (this.selected_values.length == this.options.length) {
        return this.$t("message.comply_advantage.filter_countries_all");
      }
      if (this.selected_values.length > 0) {
        return this.selected_values.map((item) => item.display_text).join(", ");
      }
      return this.placeholder;
    },
    select_style() {
      if (this.selected_values.length == 0)
        return { color: "rgba(0,0,0,.4) !important" };
      return {};
    },
  },
};
</script>
<style scoped>
.dropdown-overlay {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
}
.select {
  position: relative;
  z-index: 4;
}
.dropdown {
  position: absolute;
  z-index: 4;
  box-shadow:
    0 0.5rem 4rem rgb(0 0 0 / 11%),
    0 10px 20px rgb(0 0 0 / 5%),
    0 2px 3px rgb(0 0 0 / 6%);
  width: 100%;
  border-radius: 0.625rem;
  background: #fff;
  max-height: 150px;
  overflow: auto;
}
.dropdown ul {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}
.dropdown ul li {
  cursor: pointer;
  padding: 10px;
}
.dropdown ul li:hover {
  background: #eceeef;
}
.dropdown ul li label {
  padding: 0;
  width: 100%;
  margin-bottom: 0;
}

.dropdown ul li label input {
  margin-right: 5px;
}
.dropdown-height {
  height: calc(3.375rem + 2px) !important;
  border: 1px solid #94a4b2;
}
.dropdown-height:hover {
  border-color: #8fa4b8;
}
</style>
